import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

/**
 * SolarShift badge — pill-shaped (rounded-full) with optional dot
 * indicator. `dot` prop renders a leading circle in the accent colour.
 * Variants map to semantic tones (info/success/warning/danger/outline).
 */
const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary/15 text-primary-foreground text-foreground hover:bg-primary/25",
        secondary:
          "border-transparent bg-secondary/20 text-secondary hover:bg-secondary/30",
        destructive:
          "border-transparent bg-[hsl(var(--danger-bg))] text-[hsl(var(--danger))] hover:bg-[hsl(var(--danger-bg))]/80",
        outline:
          "text-foreground border-border bg-transparent",
        success:
          "border-transparent bg-[hsl(var(--success-bg))] text-[hsl(var(--success))]",
        warning:
          "border-transparent bg-[hsl(var(--warning-bg))] text-[hsl(var(--warning))]",
        info:
          "border-transparent bg-[hsl(var(--info-bg))] text-[hsl(var(--info))]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({ className, variant, dot = false, children, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props}>
      {dot && (
        <span
          aria-hidden="true"
          className="inline-block w-1.5 h-1.5 rounded-full bg-current"
          style={{ boxShadow: "0 0 0 3px currentColor", opacity: 0.9 }}
        />
      )}
      {children}
    </div>
  );
}

export { Badge, badgeVariants }
